import { Controller } from "@hotwired/stimulus";

// Toggles `.dark` on <html> and persists the choice to localStorage.
// Usage: data-controller="theme" + a button with data-action="theme#toggle".
export default class extends Controller {
  static targets = ["toggleButton"];

  connect() {
    this.loadThemePreference();
  }

  toggle() {
    const isDarkMode = document.documentElement.classList.toggle("dark");
    this.saveThemePreference(isDarkMode);
  }

  loadThemePreference() {
    const isDarkMode = localStorage.getItem("taywind-theme") === "dark";
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    }
  }

  saveThemePreference(isDarkMode) {
    localStorage.setItem("taywind-theme", isDarkMode ? "dark" : "light");
  }
}
